<template>
  <div>
    <div class="box info-box" v-if="isPendingManagement === true">
      <div class="box-header with-border">
          <h3 class="box-title text-warning">Pending Records</h3>
      </div>
      <!-- /.box-header -->
      <div class="box-body">
          <table class="table table-sm table-bordered table-striped table-hover">
            <thead>
              <tr>
                <td>Pending Number Of EMI today</td>
                <td>{{pendingEmiTodayNo}}</td>
              </tr>
              <tr>
                <td>Pending Amount Of EMI today</td>
                <td>{{pendingEmiTodayAmount}}</td>
              </tr>
              <tr>
                <td>Pending Number Of EMI Till today</td>
                <td>{{pendingEmiTillTodayNo}}</td>
              </tr>
              <tr>
                <td>Pending Amount Of EMI Till today</td>
                <td>{{pendingEmiTillTodayAmount}}</td>
              </tr>
              <tr>
                <td>Total Active Customer</td>
                <td>{{totalActiveCustomer}}</td>
              </tr>
              <!-- <tr>
                <td>Total Inactive Customer</td>
                <td>{{totalInactiveCustomer}}</td>
              </tr> -->
            </thead>
          </table>
                
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pendingrecords',
  data () {
    return {
      isLoading: false,
      isPendingManagement: false,
      editMode: false,
      serverParams: {
        columnFilters: {
        },
        sort: {
          field: 'paymentDate',
          type: 'date'
        },
        page: 1,
        perPage: 10
      },
      pendingEmiTillTodayNo: '',
      pendingEmiTodayNo: '',
      pendingEmiTodayAmount: '',
      pendingEmiTillTodayAmount: '',
      totalActiveCustomer: '',
      totalInactiveCustomer: ''
    }
  },
  methods: {
    pendingRecord () {
      var c = JSON.parse(localStorage.user)
      if (c.role.name === 'Manager' || c.role.name === 'Admin') {
        this.isPendingManagement = true
      }
      if (c.type === 'admin') {
        this.$axios
        .post('dashboard/emicollection', { status: 'unpaid', count: 'count' }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.pendingEmiTillTodayNo = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
        this.$axios
        .post('dashboard/emicollection', { status: 'unpaid', sum: 'sum' }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.pendingEmiTillTodayAmount = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
        this.$axios
        .post('dashboard/emicollection', { status: 'unpaid', count: 'count', today: 'today' }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.pendingEmiTodayNo = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
        this.$axios
        .post('dashboard/emicollection', { status: 'unpaid', sum: 'sum', today: 'today' }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.pendingEmiTodayAmount = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
        this.$axios
        .post('dashboard/customer', { status: 'active', count: 'count' }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.totalActiveCustomer = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      if (c.role.name === 'Manager') {
        this.$axios
        .post('dashboard/emicollection', { status: 'unpaid', count: 'count', branch_id: c.agent_profile.branch_id }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.pendingEmiTillTodayNo = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
        this.$axios
        .post('dashboard/emicollection', { status: 'unpaid', sum: 'sum', branch_id: c.agent_profile.branch_id }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.pendingEmiTillTodayAmount = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
        this.$axios
        .post('dashboard/emicollection', { status: 'unpaid', count: 'count', today: 'today', branch_id: c.agent_profile.branch_id }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.pendingEmiTodayNo = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
        this.$axios
        .post('dashboard/emicollection', { status: 'unpaid', sum: 'sum', today: 'today', branch_id: c.agent_profile.branch_id }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.pendingEmiTodayAmount = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
        this.$axios
        .post('dashboard/customer', { status: 'active', count: 'count', branch_id: c.agent_profile.branch_id }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.totalActiveCustomer = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
      }
      // this.$axios
      // .post('dashboard/customer', { status: 'inactive', count: 'count' }, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      // .then((response) => response.data)
      // .then((data) => {
      //   this.totalInactiveCustomer = data.data
      // })
      // .catch(function (error) {
      //   console.log(error)
      // })
    }
  },
  created () {
    this.pendingRecord()
  }
}
</script>
<style scoped>
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// PendingManagement.vue?4d128e45